<template>
    <DsSheet
        v-model:open="isOpen"
        size="md"
        title="Event log"
    >
        <div
            v-if="isFetching"
            class="flex items-center justify-center p-8"
        >
            <i
                aria-hidden="true"
                class="fas fa-spinner fa-pulse mr-2"
            ></i>
            <span>Loading...</span>
        </div>

        <div
            v-else-if="error"
            class="text-center"
        >
            <p>Whoops, looks like something went wrong.</p>
            <p>Please refresh the page and try again.</p>
        </div>

        <div
            v-else-if="eventLogHtml"
            v-html="eventLogHtml"
        ></div>

        <div
            v-else
            class="text-center text-ds-primary-500"
        >
            No event log data is available.
        </div>
    </DsSheet>
</template>

<script setup lang="ts">
import type { FileDetails } from '@/components/Views/Company/File/file.types';
import DsSheet from '@ds/DsSheet.vue';
import { useFetch } from '@vueuse/core';
import { computed, watch } from 'vue';

const isOpen = defineModel<boolean>('open');

const props = defineProps<{
    route: FileDetails['routes']['file_history'];
}>();

const { data, error, isFetching, execute } = useFetch(props.route, {
    immediate: false,
}).json<{
    html: string;
}>();

const eventLogHtml = computed(() => data.value?.html);

watch(isOpen, isNowOpen => {
    if (isNowOpen) {
        data.value = null;
        error.value = null;
        execute();
    }
});
</script>

<style lang="scss">
table.events.table {
    th,
    td {
        padding: 2px 5px;
        font-size: 12px;
    }
}
</style>
